import React, {useContext} from "react";
import {Form} from "antd";
import {Title} from "./Common";
import MapPropsContext from "../MapPropsContext";
import Radio from "antd/es/radio";
import Seperator from "./Seperator";
/*
사업자   : SKT, KT, LGT agency
3G      : 3g (ex: -91.13 처럼 음수로 이루어져 있다.)
4G      : 4g (ex: -121.11 처럼 음수로 이루어져 있다.)
 */
const OPTIONS_AGENCY = [
  {code: "SK", label: "SKT"},
  {code: "KT", label: "KT"},
  {code: "LG", label: "LGU+"},
];
const OPTIONS_SERVICE = [
  {code: "2G", label: "2G"},
  {code: "3G", label: "3G"},
  {code: "4G", label: "4G"},
  {code: "5G", label: "5G"},

];

function WidgetCellularDensity() {
  const {widgetState, onChangeWidgetState} = useContext(MapPropsContext);

  const {code_density} = widgetState;

  return (
    <Form.Item>
      <Radio.Group name="code_density"
                   value={code_density}
                   buttonStyle={"solid"}
                   size={"small"}
                   onChange={onChangeWidgetState}
                   style={{ width: '100%' }}>
        <Title>사업자</Title>
        <div style={{ display: 'flex', marginBottom: '1em' }}>
          {OPTIONS_AGENCY.map(({code, label}) =>
            <Radio.Button value={code} key={code} style={BUTTON_STYLE}>
              {label}
            </Radio.Button>
          )}
        </div>

        <Seperator />

        <Title>서비스</Title>
        <div style={{ display: 'flex' }}>
          {OPTIONS_SERVICE.map(({code, label}) =>
            <Radio.Button value={code} key={code} style={BUTTON_STYLE}>
              {label}
            </Radio.Button>
          )}
        </div>
      </Radio.Group>
    </Form.Item>
  );
}


const BUTTON_STYLE = {
  flex: 1,
  textAlign: 'center',
};


export default WidgetCellularDensity;